import { NAME } from './constants';
import { router } from './router';

export const Inventura = {
	name: NAME,
	router,
};
